export default __webpack_public_path__ + "static/favicon-07fedb2a9129764a9695f5003266db6e.png";